export const sample = [
  {
    name: 'Eiffel Tower',
    address: 'Eiffel Tower',
    latitude: 48.8584,
    longitude: 2.2945,
    radius: 10,
  },
];
